import { render, staticRenderFns } from "./AppMain.vue?vue&type=template&id=6beed8bc&scoped=true"
import script from "./AppMain.vue?vue&type=script&lang=js"
export * from "./AppMain.vue?vue&type=script&lang=js"
import style0 from "./AppMain.vue?vue&type=style&index=0&id=6beed8bc&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6beed8bc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/crm1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6beed8bc')) {
      api.createRecord('6beed8bc', component.options)
    } else {
      api.reload('6beed8bc', component.options)
    }
    module.hot.accept("./AppMain.vue?vue&type=template&id=6beed8bc&scoped=true", function () {
      api.rerender('6beed8bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/layout/components/AppMain.vue"
export default component.exports